import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
import { LearnerService } from '../services/learner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterService } from '../services/filter.service';
import { TimeSheetService } from '../services/time-sheet.service'
import { AddLearnerModalComponent } from '../learners/add-learner-modal/add-learner-modal.component';
import { EditLearnerModalComponent } from '../learners/edit-learner-modal/edit-learner-modal.component';
import { LearnersListModalComponent } from './learners-list-modal/learners-list-modal.component';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';
import * as  JSZip from 'jszip';
import * as JSZipUtil from 'jszip-utils'
import { JobService } from '../services/jobs/job.service';
import { DocumentService } from '../services/document.service';
import { DeleteConfirmModalComponent } from '../commons/delete-confirm-modal/delete-confirm-modal.component';
import { UtilityService } from './../services/utility.service'
import * as moment from 'moment';
import { UserRoleService } from '../services/user-role.service';
import { MarkingSchemeL3Component } from '../portfolio/marking-scheme-l3/marking-scheme-l3.component'

@Component({
  selector: 'app-learners',
  templateUrl: './learners.component.html',
  styleUrls: ['./learners.component.scss']
})
export class LearnersComponent implements OnInit {
  job;
  learners: any = [];
  showProgressbar: boolean = false
  length;
  pageSizeOptions: number[] = [25, 50, 100];
  downloadProgress = 0
  // pageSizeOptions: number[] = [5, 10, 25, 100];
  jobId;
  displayedColumns: string[] = ['name', 'email', 'actions'];
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  currentUser;
  loading: Boolean;
  allLearners: any;
  afterFilter: any;
  filterActive: Boolean = false;
  user;
  loadingFile: any = [];
  noDataMsg = {
    title: "No Learners!",
    data: "You have not yet added any learners"
  }
  courseType: any;
  allLearnersList = []
  learnerList = []
  singleJobData
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  isClient: boolean = false;
  markingSchemeComp
  singleLearner
  // @ViewChild(MarkingSchemeL3Component, { static: false }) markingSchemeComp: MarkingSchemeL3Component;
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @Input('jo') isActive: Boolean;
  @Input('jobId') jobIdFromClient;
  @Input('learnersFromJob') learnersFromJob;
  @Input('checkPolicy') hasPolicy;
  @Input('singleJob') jobDetails
  @Output() getLearnersFromComponent: EventEmitter<any> = new EventEmitter<any>();
  @Output() learnerAdded: EventEmitter<any> = new EventEmitter<any>();
  // @Output() learnersFor: EventEmitter<any> = new EventEmitter<any>();

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  constructor(
    public _learnerService: LearnerService,
    public dialog: MatDialog,
    public _filter: FilterService,
    public _snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private _jobService: JobService,
    public documentService: DocumentService,
    public router: Router,
    public _utilityService: UtilityService,
    public _timeSheetService: TimeSheetService,
    public _userRoleService: UserRoleService

  ) {
    this.learners = [];
    this.dataSource = new MatTableDataSource(this.learners);

    this._learnerService.markingSchemeSubmit().subscribe((data) => {
      console.log("When form is submitted", data);

      this.downloadPortfolio()


    })

  }

  ngOnInit() {
    this.markingSchemeComp = new MarkingSchemeL3Component(null, null, this._learnerService, null, null, null)
    // this.markingSchemeComp.ngOnInit()
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.activatedRoute.queryParams.subscribe(qparams => {
      if (qparams.courseType) {
        this.courseType = qparams.courseType
      }
    })
    this.getAllLearnerList()

    console.log("*****Learners from job", this.learnersFromJob);
    console.log("%c*****job", "color:red", this.job);
    this.user = JSON.parse(localStorage.getItem('userRoles'))

    console.log("jobIdFromClient", this.jobIdFromClient);
    if (this.jobIdFromClient != undefined) {
      this.jobId = this.jobIdFromClient
      this.learners = this.learnersFromJob
    }
    else {
      this.activatedRoute.params.subscribe(params => {
        console.log("params value without=====", params);

        this.jobId = params['jobid'];
        console.log("Calling getLearnersFromComponent with jobid = ", this.jobId);
      })
    }
    // this.getLearners(this.jobId);
    this.learners = this.learnersFromJob
    this.getJob(this.job);
    this.currentUser = JSON.parse(localStorage.currentUser);
    const paginatorIntl = this.paginator._intl;
    paginatorIntl.nextPageLabel = '';
    paginatorIntl.previousPageLabel = '';
  }

  // ngOnDestroy() {
  //   this.queryParams.next();
  // }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes in learner component", changes);
    if (changes.learnersFromJob && changes.learnersFromJob.currentValue) {
      this.learners = changes.learnersFromJob.currentValue
      this.learnerList = changes.learnersFromJob.currentValue
      this.loading = false;
      console.log("all learners list with therir status", this.learners);

      this.updateData(this.learners)
    }
    if (changes.jobIdFromClient && changes.jobIdFromClient.currentValue) {
      this.jobId = changes.jobIdFromClient.currentValue

      // this.getUserRole();
    }

    if (changes.hasPolicy && changes.hasPolicy.currentValue) {
      this.hasPolicy = changes.hasPolicy.currentValue
    }
    if (changes.jobDetails && changes.jobDetails.currentValue) {
      let objLength = Object.keys(changes.jobDetails.currentValue).length
      console.log("Changes in job", changes.jobDetails, objLength);
      if (objLength != 0) {
        this.singleJobData = changes.jobDetails.currentValue
        this.getUserRole();
        console.log("this.jobId............", this.singleJobData);
        this.courseType = this.singleJobData.course.type;
        console.log("check the new course type ***********************", this.courseType)
      }
    }

  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.singleJobData.instructors, 'job');
    console.log("hello get the role of users ....", getRole)
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true
    else if (getRole.isClient) this.isClient = true

  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    // console.log("Here console the compnent data", this.markingSchemeComp);


  }

  generatePdf(learner) {
    console.log("single job details", this.job);

    this.singleLearner = learner

    // if (this.job && this.job.course._id == "5ecd0b8e943959723eebba15") {
    if (this.job && this.job.course._id == "611dd27dacbcd448e898090c") {
      this.displaySnackBar("It takes about 15 minutes to generate pdf. It will be mailed to you once the generation process is complete.", "Ok");
      console.log("DOWNLOAD PDF CLICKED", learner)
      console.log("currentUser", this.currentUser)
      let obj = {
        email: this.currentUser.email,
        learnerId: learner._id,
        learnerName: learner.name,
        courseId: this.job.course._id,
        jobId: this.jobId,
        policySequence: this.job.jobMeta.policySequence,
        courseTitle: this.job.course.title,
        sequence: this.job.jobMeta.sequence,
        extraPages: this.job.jobMeta.extraPages,
        lastPages: this.job.jobMeta.lastPages
      }
      console.log("job data", this.job);
      // if (this.job.course._id == "5ecd0b8e943959723eebba15") {
      if (this.job.course._id == "611dd27dacbcd448e898090c") {
        obj['version'] = true
      } else {
        obj['version'] = false
      }

      console.log("this is for old portfolio", obj);
      this._learnerService.getPdfByLearner(obj).subscribe(res => {
        console.log("res===============", res)
        // this.saveToFileSystem(res, learner)
      })
    } else {
      if (this.job.course && ((this.job.course.courseMetaId.sequence && !this.job.course.courseMetaId.sequence.length) && (this.job.course.courseMetaId.policySequence && !this.job.course.courseMetaId.policySequence.length))) {
        console.log("this is for no downloads");
        this.displaySnackBar(" Download not available", "Ok");
      } else {
        this.displaySnackBar("It takes about 15 minutes to generate pdf. It will be mailed to you once the generation process is complete.", "Ok");
        console.log("DOWNLOAD PDF CLICKED", learner)
        console.log("currentUser", this.currentUser)
        let obj = {
          email: this.currentUser.email,
          learnerId: learner._id,
          learnerName: learner.name,
          courseId: this.job.course._id,
          jobId: this.jobId,
          policySequence: this.job.jobMeta.policySequence,
          courseTitle: this.job.course.title,
          courseLevel: this.job.course.type,
          sequence: this.job.jobMeta.sequence,
          extraPages: this.job.jobMeta.extraPages,
          lastPages: this.job.jobMeta.lastPages
        }
        console.log("job data", this.job);
        if (this.job.course._id == "5ecd0b8e943959723eebba15") {
          obj['version'] = true
        } else {
          obj['version'] = false
        }
        console.log("send obj", obj);

        if (this.job.course.templateId == '5e0f9b43b2987906e9dad9c8') {

          // console.log("Here the console of marking scheme comp", this.markingSchemeComp);
          let markingObj = { learnerId: learner._id, jobId: this.job._id }

          // this.documentService.updateMarkingScheme(obj)

          this.markingSchemeComp.markingSubmit(markingObj)
          // .then((done) => {
          //   console.log("Marking scheme done", done);
          // setTimeout(() => {

          //   this._learnerService.getPdfByLearner(obj).subscribe(res => {
          //     console.log("res===============", res)
          //     // this.saveToFileSystem(res, learner)
          //   })
          // }, 1000)
          // }).catch((err) => {
          //   console.log("This is the error", err);

          // })
        } else {
          console.log("THis is for new course portfolio");

          this._learnerService.getPdfByLearner(obj).subscribe(res => {
            console.log("res===============", res)
            // this.saveToFileSystem(res, learner)
          })
        }
      }
    }




  }


  downloadPortfolio() {
    let obj = {
      email: this.currentUser.email,
      learnerId: this.singleLearner._id,
      learnerName: this.singleLearner.name,
      courseId: this.job.course._id,
      jobId: this.jobId,
      policySequence: this.job.jobMeta.policySequence,
      courseTitle: this.job.course.title,
      courseLevel: this.job.course.type,
      sequence: this.job.jobMeta.sequence,
      extraPages: this.job.jobMeta.extraPages,
      lastPages: this.job.jobMeta.lastPages
    }
    this._learnerService.getPdfByLearner(obj).subscribe(res => {
      console.log("res===============", res)
      // this.saveToFileSystem(res, learner)
    })
  }

  downloadPdf(learner) {
    this.openSnackBar("Download will start automatically.", "Ok");
    this._learnerService.downloadPdfByLearner(learner._id, this.jobId).subscribe(res => {
      console.log("res for downloadPdf Function", res)
      if (res) {
        saveAs(res, "Portfolio-" + learner.name)
      } else {
        this.openSnackBar("Please generate the PDF.", "OK")
      }
      // this.saveToFileSystem(res, learner)
    })
  }

  private saveToFileSystem(response, learner) {
    let byteArray = new Uint8Array(response.data);
    let blob = new Blob([byteArray], { type: 'application/pdf' });
    this.loading = false;
    saveAs(blob, "portfolio" + learner.name);
  }


  applyFilter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    if (searchText === '') {
      this.updateData(this.learners);
      this.filterActive = false;
    }
    let filteredLearner = this._filter.filter(searchText, this.learners, ['name']);
    this.updateData(filteredLearner);
    if (filteredLearner.length <= 0) {
      this.afterFilter = {
        title: "No Learners!",
        data: "No learners with matched search text found!"
      }
    }
  }

  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }


  // UTILITY

  updateData(learners) {
    console.log("UPDATING DATA = ", learners)
    console.log("Emitting event getLearnersFromComponent with learners = ", learners);
    this.getLearnersFromComponent.emit({ learners })
    this.dataSource = new MatTableDataSource(learners);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;

  }

  redirect(learner) {
    this.router.navigate(['/learner/view/' + learner._id], { queryParams: { job: this.jobId } })
  }



  // MODALS
  addLearnerModal() {
    console.log("total learner list", this.learners);
    this._timeSheetService.getSystemDate().subscribe((date) => {
      console.log("this is the system date", date);


      let addedlearner = this.openDialog(AddLearnerModalComponent, { job: this.jobId, jobDetails: this.singleJobData, multiple: true, date: date.systemDate }).subscribe((learner) => {
        console.log("learner added in controller = ", this.learners);
        if (learner != undefined) {
          let index = this.learners.findIndex(x => x._id === learner._id);
          console.log("what is the index of new learner added", index);
          if (index == -1) {
            this.learners.push(learner);
          }
          if (this.courseType && this.courseType != 'Level2') {
            this.learnerAdded.emit({ learner })
          }
          console.log("after new learner added value", this.learners);

          this.openSnackBar("Learner added successfully!", "Ok");
          this.updateData(this.learners);
        }
      }, err => {
        return this.openSnackBar("Learner could not be added!", "Ok");
      });
    })
  }


  editLearnerModal(index, data) {

    this.openDialog(EditLearnerModalComponent, data).subscribe((data) => {
      console.log("DIALOG CLOSED", data)
      // Handle Error
      if (!data) return;// this.openSnackBar("learner could not be edited","Ok");
      if (data.result == "err") return this.openSnackBar("Learner could not be edited!", "Ok");

      // EDIT HANDLE
      if (data.action == 'edit') {
        console.log("HANDLING EDIT SUCCESS", data);
        data = data;
        let index = this.learners.findIndex(function (i) {
          return i._id === data._id;
        })
        this.learners[index] = data.data;
        this.handleSnackBar({ msg: "Learner edited successfully!", button: "Ok" });
      }
      // DELETE HANDLE
      else if (data.action == 'delete') {
        console.log("Deleted ", data);
        this.learners.splice(this.learners.findIndex(function (i) {
          return i._id === data.data._id;
        }), 1);
        this.handleSnackBar({ msg: "Learner deleted successfully!", button: "Ok" });
      }
      this.updateData(this.learners);
    });
  }


  learnerListModal() {
    console.log("all learner list to display", this.allLearnersList);
    let obj = {
      learnerList: this.allLearnersList,
      jobId: this.jobId
    }
    let data = obj
    this.openDialog(LearnersListModalComponent, data).subscribe((res: any) => {
      console.log("response when new learner added", res);
      if (res != undefined) {
        this.getAllLearnerList()
        console.log("learners list", this.learners);
        this.learners = res.data
        this.updateData(this.learners)
        // let msg = "Learners added successfully"
        this.handleSnackBar({ msg: "Learners added successfully", button: "OK" })
      }
    })
  }



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  displaySnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
    });
  }



  // API CALLS

  getLearners(jobId) {
    let that = this;
    this.loading = true;
    console.log("Getting learners for jobid = ", jobId);
    this._learnerService.getLearnersByJobIdV2(jobId).subscribe((learners) => {
      this.learners = learners;
      for (let i = 0; learners.length; i++) {
        this.learners[i].status = false
      }
      this.learnerList = learners
      console.log("EVENT EMITTED FROM LEARNER COMP");
      this.getLearnersFromComponent.emit({ learners })
      this.loading = false;
      console.log("GOT LeARNERS", this.learners);
      this.updateData(learners)
    });
  }


  getJob(jobId) {
    this.loading = true;
    let that = this;
    console.log("Getting JOB for jobid = ", this.jobId, jobId);
    this._jobService.getJobById(this.jobId).subscribe((jobs) => {
      console.log("Job Received = ", jobs);
      this.loading = false;
      this.job = jobs.data.pop();
      console.log("final job details", this.job);

      // console.log({ job: this.job });
    });
  }

  downloadAssignmentReport(learnerId, learnerName) {
    console.log(" Learner Id ", learnerId)
    let obj = {
      jobId: this.jobId,
      learnerId: learnerId
    }
    this.loading = true;
    this._learnerService.downloadAssignmentReport(JSON.stringify(obj))
      .subscribe((res) => {
        console.log(" RES for the download PDF ", res)
        if (res && res.data && res.data.bufferData) {
          console.log(" Buffer data ")
          let byteArray = new Uint8Array(res.data.bufferData.data)
          let blob = new Blob([byteArray], { type: 'application/pdf' })
          saveAs(blob, learnerName);
          this.loading = false
          console.log(" Done PDF process ");
        }
        else {
          this.loading = false
        }

      }, (error) => {
        console.log("error while generate pdf", error);
        this.loading = false
      })
  }
  generateProtfolios() {
    this.openSnackBar("Generate learners portfolio request submitted and learners portfolio will be send to your mail.", "Ok");
    console.log("currentUser", this.currentUser)

    console.log(this.jobId)

    this._learnerService.generateProtfolios(this.jobId).subscribe(res => {
      console.log("res===============", res)
      // this.saveToFileSystem(res, learner)
    })
  }

  // downloadSubmissionsFiles(learnerId, learnerName, i) {
  //   console.log(" downloadSubmissionsFiles ", this.job)
  //   let obj = {
  //     learnerId: learnerId,
  //     jobId: this.job._id
  //   }
  //   this.learners[i].status = true;
  //   this._learnerService.downloadSubmissionsFiles(JSON.stringify(obj))
  //     .subscribe((res) => {
  //       console.log(" RES for the download PDF ", res)
  //       if (res != undefined) {

  //         this.showProgressbar = true;
  //         console.log("res.data.files", res.files)
  //         this.makeZip(res.files, learnerName, i)
  //           .then((response) => {
  //             console.log('All File Download Here');
  //             this.showProgressbar = false;
  //           })
  //           .catch((error) => {
  //             console.log('Catch Error Here', error);
  //           })
  //       } else {
  //         this.openSnackBar("No submissions for this learner.", "Ok");
  //         // this.showProgressbar = false;
  //         this.learners[i].status = false;
  //       }
  //     })
  // }

  // downloadRapForms(id, name, index) {
  //   console.log("id, name, index", id, name, index);
  //   if (id != undefined && this.jobId != undefined) {
  //     let obj = {
  //       learner: id,
  //       jobId: this.jobId,
  //       title: 'RAP'
  //     }
  //     console.log("obj to be send", obj);
  //     this.openSnackBar("Download will start automatically.", "Ok");
  //     this.documentService.downloadAllRaps(obj).subscribe((res) => {
  //       console.log("response get with merged url", res);
  //       if (res && res.data) {
  //         let title
  //         title = name + '_rap' + '_' + moment(new Date).format("DD-MM-YYYY") + '.pdf'
  //         saveAs(res.data, title);
  //         this.openSnackBar("PDF downloaded successfully!", "Ok");
  //       } else {
  //         console.log("this is the another response");
  //         this.openSnackBar(res.msg, "Ok");
  //       }
  //     })
  //   }
  // }

  downloadSubmissionsFiles(learnerId, learnerName, i) {
    console.log(" downloadSubmissionsFiles ", this.job)
    let obj = {
      learnerId: learnerId,
      jobId: this.job._id
    }
    this.learners[i].status = true;
    this.loading = true
    this._learnerService.downloadSubmissionsFiles(JSON.stringify(obj))
      .subscribe((res) => {
        console.log(" RES for the download PDF ", res)

        if (res != undefined) {
          const downloadLink = document.createElement("a");
          downloadLink.href = res.zip;
          downloadLink.download = learnerName;
          downloadLink.click();
          this.showProgressbar = false;
          this.learners[i].status = false;

        } else {

          this.openSnackBar("No submissions for this learner.", "Ok");
          this.learners[i].status = false;
        }
        this.loading = false
      })
  }

  makeZip(fileList, folderName, i) {
    let count = 0;
    let zip: any = new JSZip();
    let fileArray = fileList;
    let percent = 100 / fileArray.length;
    let download = 0;

    return new Promise((resolve, reject) => {
      if (fileArray && fileArray.length) {
        fileArray.forEach(async file => {
          const result = await this.downloadOne(file)
          let filename = file.path.split("/")[3];
          download = download + percent;
          this.downloadProgress = download;
          console.log("this.downloadProgress===>", this.downloadProgress);
          zip.file(filename, result, { binary: true });
          count++;
          console.log(" count ", count, "fileArray.length", fileArray.length)
          if (count == fileArray.length) {
            console.log(" star ", zip);
            zip.generateAsync({ type: 'blob' }).then((content) => {
              console.log(" Test Here * ")
              saveAs(content, folderName);
              this.learners[i].status = false;
              resolve()
            });
          }
        })
      } else {
        this.showProgressbar = false;
        resolve();
      }
    })
  }

  downloadOne(file) {
    return new Promise((resolve, reject) => {
      JSZipUtil.getBinaryContent(file.path, {
        progress(e) {
          // console.log("progress Event", e);
        }
      }).then((e) => {
        console.log('Download Complete', e);
        resolve(e)
      })
    })
  }


  getAllLearnerList() {
    console.log("what is the job id========", this.jobId);
    this._learnerService.getLearanerList(this.jobId).subscribe((res: any) => {
      this.allLearnersList = res
      console.log("response of all learaners list which are not in this job", this.allLearnersList);
    }, error => {
      console.log("error while get all learners list", error);

    })
  }



  downloadIlpForm(learner, name) {
    console.log("learner id to download form", learner);
    this.loading = true
    console.log("name of learner ", name);
    let obj = {
      learner: learner,
      jobId: this.jobId,
      courseType: this.courseType
    }
    this.documentService.downloadIlpFormPdf(obj).subscribe((res) => {
      console.log("here is reponse for the download document!!!", res)
      let byteArray = new Uint8Array(res.data.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let title = name + '_ilp' + '_' + moment(new Date).format("DD-MM-YYYY")
      saveAs(blob, title);
      this.loading = false
    }, (error) => {
      this.loading = false
      console.log("reponse failed download ilp form", error);
    })
  }

  removeLearner(learner) {
    console.log("remove learner details", learner);
    console.log("job id", this.jobId);

    this.openDialog(DeleteConfirmModalComponent, 'learner').subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._learnerService.removeLearnerFromJob(learner._id, this.jobId).subscribe((response: any) => {
          console.log("learner remove from job", response);
          let index = this.learnerList.findIndex(x => x._id == response._id);
          console.log("index of found leaner", index);
          this._utilityService.openSnackBar("Learner Remove From Job Successfully", "Ok")
          // this.openSnackBar("Learner Remove From Job Successfully", "Ok");


          console.log("hello here is the learner list===>", index, this.learnerList)
          if (index > -1) {
            this.learnerList.splice(index, 1)
            console.log("after learner remove list", this.learnerList);
            this.updateData(this.learnerList)
          }
        }, error => {
          console.log("error while remove learner", error);
          this.openSnackBar("Something went wrong", "Ok");
        })
      }
    })

  }

}
